// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Cf06","title":"ClientReferral_title__vWsGd","itemText":"ClientReferral_itemText__2XVRi"};